import { useAuthContext } from '../context/auth'
import { useUserContext } from '../context/user'
import usePersist from './usePersist'
import axios from '../api/axios'
import socket from '../utils/socket'
import { forgetPushOnServer } from '../utils/push'

export const useLogout = () => {
  const { auth, dispatch } = useAuthContext()
  const { dispatch: dispatchUsers } = useUserContext()
  const { setPersist } = usePersist()

  const logout = async () => {
    try {
      // useAxiosPrivate itself uses useLogout, so it can't be used here: send the token by hand.
      // The browser stops getting my notifications; this never blocks the logout for more than 3 seconds.
      const token = auth?.accessToken
      if (token) {
        const withToken = {
          post: (url, body) =>
            axios.post(url, body, { headers: { Authorization: `Bearer ${token}` } }),
        }

        await Promise.race([
          forgetPushOnServer(withToken),
          new Promise((resolve) => setTimeout(resolve, 3000)),
        ])
      }

      await axios.post('/api/auth/logout')
      dispatch({ type: 'LOGOUT' })
      dispatchUsers({ type: 'SET_USER', payload: null })
      setPersist(false)
      socket.disconnect()
    } catch (error) {
      // console.log(error)
    }
  }

  return { logout }
}